var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayStoreAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 47,
    viewBox: "0 0 130 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130 42.1062C130 44.6373 128.326 46.6875 126.256 46.6875H3.7484C1.67941 46.6875 0 44.6373 0 42.1062V5.57167C0 3.04178 1.67941 0.984375 3.7484 0.984375H126.256C128.326 0.984375 129.999 3.04178 129.999 5.57167L130 42.1062Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2638 34.2656H59.1443L55.0104 22.816H53.0902L48.9563 34.2656H50.8051L51.8524 31.1711H56.2164L57.2638 34.2656ZM54.0106 24.7203H54.0582L55.7642 29.7429H52.3047L54.0106 24.7203ZM60.2313 34.2656H61.9531V29.2906C61.9531 27.9338 62.7307 27.0293 64.032 27.0293C65.2936 27.0293 65.8966 27.7593 65.8966 29.0685V34.2656H67.6184V28.7432C67.6184 26.7595 66.5314 25.5535 64.6271 25.5535C63.2941 25.5535 62.4292 26.0851 61.9055 27.1007H61.8738V25.6487H60.2313V34.2656ZM72.5854 34.3529C73.847 34.3529 74.8309 33.7816 75.3387 32.8057H75.3705V34.2656H77.0367V22.3003H75.3229V27.0769H75.2832C74.7913 26.1248 73.8074 25.5614 72.5696 25.5614C70.4272 25.5614 68.9514 27.2991 68.9514 29.9492C68.9514 32.6152 70.4272 34.3529 72.5854 34.3529ZM73.0219 27.0214C74.4025 27.0214 75.3308 28.2036 75.3308 29.9572C75.3308 31.7186 74.4025 32.8929 73.0219 32.8929C71.6254 32.8929 70.7129 31.7424 70.7129 29.9572C70.7129 28.1798 71.6333 27.0214 73.0219 27.0214ZM78.8617 34.2656H80.5835V29.124C80.5835 27.91 81.2976 27.1245 82.4323 27.1245C82.7734 27.1245 83.075 27.1721 83.2178 27.2277V25.6169C83.0829 25.5852 82.8687 25.5614 82.6147 25.5614C81.5991 25.5614 80.8057 26.1406 80.5359 27.1007H80.5042V25.6487H78.8617V34.2656ZM87.6453 34.3688C90.1367 34.3688 91.7157 32.6708 91.7157 29.9572C91.7157 27.2435 90.1288 25.5376 87.6453 25.5376C85.1617 25.5376 83.5669 27.2515 83.5669 29.9572C83.5669 32.6708 85.1538 34.3688 87.6453 34.3688ZM87.6453 32.9406C86.1853 32.9406 85.3125 31.8376 85.3125 29.9572C85.3125 28.0846 86.1853 26.9658 87.6453 26.9658C89.1052 26.9658 89.9701 28.0767 89.9701 29.9572C89.9701 31.8376 89.1052 32.9406 87.6453 32.9406ZM93.1598 34.2656H94.8816V25.6487H93.1598V34.2656ZM94.0247 24.4188C94.5801 24.4188 95.0323 23.9745 95.0323 23.427C95.0323 22.8636 94.5801 22.4352 94.0247 22.4352C93.4692 22.4352 93.017 22.8636 93.017 23.427C93.017 23.9745 93.4692 24.4188 94.0247 24.4188ZM99.9597 34.3529C101.221 34.3529 102.205 33.7816 102.713 32.8057H102.745V34.2656H104.411V22.3003H102.697V27.0769H102.657C102.166 26.1248 101.182 25.5614 99.9438 25.5614C97.8015 25.5614 96.3257 27.2991 96.3257 29.9492C96.3257 32.6152 97.8015 34.3529 99.9597 34.3529ZM100.396 27.0214C101.777 27.0214 102.705 28.2036 102.705 29.9572C102.705 31.7186 101.777 32.8929 100.396 32.8929C98.9996 32.8929 98.0872 31.7424 98.0872 29.9572C98.0872 28.1798 99.0076 27.0214 100.396 27.0214Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9905 16.4808V15.7935H52.323V16.6935H53.8341L53.8286 16.7917C53.8068 17.6264 53.1522 18.1937 52.203 18.1937C51.0738 18.1937 50.3647 17.3372 50.3647 15.9353C50.3647 14.5552 51.0411 13.7424 52.1758 13.7424C52.9449 13.7424 53.5231 14.1515 53.7413 14.8443H54.936C54.7287 13.5842 53.6322 12.7332 52.1703 12.7332C50.3156 12.7332 49.1591 13.9497 49.1591 15.9462C49.1591 17.97 50.3156 19.1974 52.1921 19.1974C53.9486 19.1974 54.9905 18.1773 54.9905 16.4808ZM60.1892 18.09H57.2216V16.3935H60.031V15.4553H57.2216V13.846H60.1892V12.8423H56.0379V19.0938H60.1892V18.09ZM64.0677 19.0938V13.846H65.9933V12.8423H60.9638V13.846H62.8894V19.0938H64.0677ZM70.6519 19.0938V16.579H73.3139V15.6189H70.6519V13.846H73.5649V12.8423H69.4682V19.0938H70.6519ZM77.3507 12.7332C75.4741 12.7332 74.3068 13.9769 74.3068 15.968C74.3068 17.9591 75.4741 19.1974 77.3507 19.1974C79.2163 19.1974 80.3891 17.9591 80.3891 15.968C80.3891 13.9769 79.2163 12.7332 77.3507 12.7332ZM77.3507 13.7533C78.4689 13.7533 79.1781 14.6097 79.1781 15.968C79.1781 17.3263 78.4689 18.1828 77.3507 18.1828C76.2215 18.1828 75.5123 17.3263 75.5123 15.968C75.5123 14.6097 76.2269 13.7533 77.3507 13.7533ZM82.5984 13.7969H83.8639C84.5731 13.7969 85.015 14.2006 85.015 14.8334C85.015 15.488 84.6004 15.8698 83.8858 15.8698H82.5984V13.7969ZM82.5984 16.7699H83.8258L85.064 19.0938H86.4169L85.0313 16.5844C85.7896 16.3117 86.226 15.6244 86.226 14.8061C86.226 13.5951 85.3968 12.8423 83.9949 12.8423H81.4146V19.0938H82.5984V16.7699Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7178 9.56332C12.3819 9.91467 12.1875 10.4617 12.1875 11.1701V36.4382C12.1875 37.1466 12.3819 37.6936 12.7178 38.0449L12.8007 38.1221L26.9718 23.9684V23.6342L12.8007 9.48049L12.7178 9.56332Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6909 28.6885L26.9725 23.9682V23.634L31.6966 18.9137L31.8024 18.9751L37.3971 22.1558C38.9937 23.0584 38.9937 24.5438 37.3971 25.4521L31.8024 28.6271L31.6909 28.6885V28.6885Z",
    fill: "url(#paint1_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8015 28.628L26.9716 23.802L12.7177 38.0457C13.248 38.6027 14.1127 38.6698 15.0962 38.1128L31.8015 28.628",
    fill: "url(#paint2_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8015 18.9748L15.0962 9.48999C14.1127 8.93869 13.248 9.00582 12.7177 9.56283L26.9716 23.8008L31.8015 18.9748Z",
    fill: "url(#paint3_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 25.7136,
    y1: 36.7013,
    x2: 6.53835,
    y2: 17.5104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 39.4762,
    y1: 23.7995,
    x2: 11.8066,
    y2: 23.7995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 29.1752,
    y1: 21.1786,
    x2: 3.17204,
    y2: -4.84596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.12963,
    y1: 46.451,
    x2: 20.7412,
    y2: 34.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStoreAndroid);
export default __webpack_public_path__ + "static/media/play-store-android.7ec7fd6b5fb3b10f549b19c1abd4d36f.svg";
export { ForwardRef as ReactComponent };